import { PRODUCT_DELETE_RECEIVE } from '../../../ActionsConst';
import { showToast } from '../../../core/actions/toast/ToastActions';
import { undoDeleteRequestAction } from '../undo-delete/UndoDeleteActions';
import { productChange } from '../change/ChangeActions';
import { productSettings } from '../settings/SettingsActions';
import { productsApiCall } from '../products/ProductsActions';
import toastMsg from '../../../../data/toast';
import AnalyticsClient from '../../../../clients/AnalyticsClient';
import productEvents from '../../../../analytics/events/products';

const successToast = (message, action, id) =>
  showToast({
    id,
    message,
    action,
  });

const errorToast = (deletedCount, id) =>
  showToast({
    id,
    error: true,
    message: {
      messageDescriptor: toastMsg.productErrorDeleteMessage, // "Sorry - we couldn't delete your product"
      values: { deletedProducts: deletedCount },
    },
  });

export const productDeleteReceive = (ids) => ({
  ids,
  type: PRODUCT_DELETE_RECEIVE,
});

const productSettingsEmptyState = (props) => ({
  total: 0,
  start: 0,
  hasMore: false,
  ...props,
});

const productSettingsSingleDelete = (currentItems) => {
  const newTotal = Math.max(currentItems - 1, 0);
  if (newTotal === 0) {
    return productSettingsEmptyState();
  }

  return { total: newTotal };
};

const productSettingsMultipleDelete = (currentItems, deletedItems) => {
  const newTotal = Math.max(currentItems - deletedItems, 0);

  if (newTotal === 0) {
    return productSettingsEmptyState({ isDeleting: false, isDeleted: true });
  }

  return {
    total: newTotal,
    isDeleting: false,
    isDeleted: true,
  };
};

const singleDelete = ({ error, ids, store, requestId }) => {
  const { dispatch } = store;
  const deletedId = ids[0];
  if (error) {
    dispatch(productChange(deletedId, { isDeleting: false, isDeleted: false }));
    dispatch(errorToast(ids.length, requestId));
    return;
  }

  const currentItems = store.getState().productSettings.total;

  dispatch(productChange(deletedId, { isDeleting: false, isDeleted: true, isChecked: false }));
  dispatch(productDeleteReceive(ids));
  dispatch(productSettings(productSettingsSingleDelete(currentItems)));

  const successMessage = { messageDescriptor: toastMsg.singleProductSuccessDeleteMessage }; // "Goodbye! The product has been deleted."
  const undeleteAction = () => dispatch(undoDeleteRequestAction(ids, requestId));

  dispatch(successToast(successMessage, undeleteAction, requestId));

  AnalyticsClient.trackEvent(productEvents.singleDelete());
};

const multipleDelete = ({ jsonResponse, error, store, ids, requestId }) => {
  const { dispatch } = store;

  if (error) {
    dispatch(productSettings({ isDeleting: false, isDeleted: false }));
    dispatch(errorToast(ids.length, requestId));
    return;
  }
  const currentItems = store.getState().productSettings.total;
  const deletedItemIds = jsonResponse.deleted;
  const successMessage = {
    messageDescriptor: toastMsg.multipleProductSuccessDeleteMessage, // "Goodbye! You have deleted X products"
    values: { productCount: jsonResponse.succeeded },
  };
  const undeleteAction = () => dispatch(undoDeleteRequestAction(deletedItemIds, requestId));

  dispatch(productDeleteReceive(deletedItemIds));
  dispatch(productSettings(productSettingsMultipleDelete(currentItems, jsonResponse.succeeded)));
  dispatch(successToast(successMessage, undeleteAction, requestId));

  setTimeout(() => {
    dispatch(productSettings({ isDeleted: false }));
  }, 2000);

  AnalyticsClient.trackEvent(productEvents.bulkDelete());
};

export const deleteRequest = ({ ids, excludedIds, isBulkMode, requestId }) => (dispatch) => {
  dispatch(
    productsApiCall({
      ids,
      excludedIds,
      requestId,
      method: 'DELETE',
      url: isBulkMode ? 'print-products' : `print-products/${ids[0]}`,
      callback: isBulkMode ? multipleDelete : singleDelete,
      urlConfig: {
        sendIds: ids.length > 0,
        sendPaging: false,
        sendFilters: ids.length === 0, // Bulk action requires filters
      },
    }),
  );
};
